import { STATISTICS_TYPES } from "../devices/page/picker";
import type { Widget } from "../../widgets/types";
import type { WidgetPage } from "../devices/page/queries";

/**
 * The plan a saved widget needs when its device's plan does not allow its type (VisionPlatform plan-dashboards PD-12):
 * the widget stays and shows "Needs the <plan> plan" instead of its content, until an upgrade. The Pro statistics
 * widgets draw their own lock with See plans (pro-statistics PST-04), so they need nothing here.
 */
export function neededPlan(widget: Pick<Widget, "type">, page: WidgetPage | undefined): string | undefined {
  if (!page || STATISTICS_TYPES.includes(widget.type)) return undefined;
  return page.plan_widgets?.needs?.[widget.type];
}

/** The device a widget shows, the first it binds or lists. */
export function widgetDevice(widget: Widget): string | undefined {
  return widget.bindings?.[0]?.device ?? widget.source?.devices?.[0];
}
